import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import PageWrapper from "../../components/common/layout/PageWrapper";
import SuggestionEdit from "../../components/services/suggestion/SuggestionEdit";

const SuggestionEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <SuggestionEdit />
    </PageWrapper>
  );
};
export default SuggestionEditPage;
